export enum AlertType {
  UNKNOWN_ALERT_TYPE = 'UNKNOWN_ALERT_TYPE',
  LONG_STAY_ALERT = 'LONG_STAY_ALERT',
  LOW_BATTERY_ALERT = 'LOW_BATTERY_ALERT',
  FAILURE_ALERT = 'FAILURE_ALERT'
}
